import type { MouseEvent } from "react";
import { Menu } from "@headlessui/react";
import classNames from "classnames";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { Checkbox } from "@circle-react-uikit/Form/Checkbox";

interface NotificationType {
  label: string;
  value: string;
}

export interface NotificationOptionCheckboxProps {
  isChecked: boolean;
  notificationType: NotificationType;
  onChange: (fieldKey: string, shouldEnable: boolean) => void;
}

export const NotificationOptionCheckbox = ({
  notificationType,
  isChecked,
  onChange,
}: NotificationOptionCheckboxProps) => {
  const onChangeHandler = () => {
    onChange(notificationType.value, !isChecked);
  };

  const onClickHandler = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onChangeHandler();
  };

  return (
    <Menu.Item>
      {({ active }) => (
        <button
          type="button"
          onClick={onClickHandler}
          key={notificationType.label}
          className={classNames(
            "hover:bg-tertiary text-xs-plus m-0 flex w-full items-center gap-3 rounded-lg px-3 py-2 font-medium transition-colors duration-200",
            {
              "bg-tertiary": active,
            },
          )}
        >
          <span className="flex min-h-[1.25rem] w-4 self-start pt-0.5">
            <Checkbox
              checked={isChecked}
              name={notificationType.value}
              id={notificationType.value}
              isFormItem={false}
              onChange={onChangeHandler}
            />
          </span>
          <label
            className="mb-0 flex text-left"
            htmlFor={notificationType.value}
          >
            <Typography.LabelXsPlus weight="medium">
              {notificationType.label}
            </Typography.LabelXsPlus>
          </label>
        </button>
      )}
    </Menu.Item>
  );
};
